import { useState } from "react";
import { BulkDelete } from "../../../../services/ProductService/AllProductList/AllProductServices";

const DeleteConfirmationPopup = ({ onClose, onSelectedId, onConfirm }) => {
  const [isDeleted, setIsDeleted] = useState(false);

  const handleBulkDelete = async () => {
    if (onSelectedId.length === 0) return;

    const data = { product_ids: onSelectedId };

    try {
      await BulkDelete("DELETE", data);
      setIsDeleted(true);

      // Call the onConfirm function after successful deletion
      if (onConfirm) onConfirm();

      // Close the popup after 1.5 seconds
      setTimeout(() => {
        setIsDeleted(false);
        onClose();
      }, 1500);
    } catch (error) {
      console.error("Error deleting products:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        {isDeleted ? (
          <p className="text-green-600 font-semibold text-lg">Successfully deleted selected products!</p>
        ) : (
          <>
            <p className="text-gray-800 font-semibold text-lg">
              Do you want to delete all selected products?
            </p>
            <div className="mt-4 flex justify-center gap-4">
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded" onClick={onClose}>
                Cancel
              </button>
              <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={handleBulkDelete}>
                Delete
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DeleteConfirmationPopup;
